export default {"src":"/_next/static/media/carFilled_24.b9ab05c1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};